import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import gql from "graphql-tag";
import { useSelector, useDispatch } from "react-redux";

import {
    getMarketingMessage,
    setMarketingMessage,
} from "frontend/store/marketing-message";

// GQL
// Making Updates to this query? Please match the update in
// `noun_project/notifications/test_marketing_header_message_graphql.py`
// on`marketingHeaderMessage` - we pre-cache this query in Apollo SSR
export const GET_MARKETING_MESSAGE_MODAL = gql`
    query marketingHeaderMessage {
        marketingHeaderMessage {
            ctaTarget
            ctaText
            ctaUrl
            headerMessage
            modalHeadline
            modalImageUrl
            modalMessage
        }
    }
`;

export const useMarketingMessageModal = () => {
    // marketing message fetched server-side
    const userMessage = useSelector(getMarketingMessage);

    // marketing message refetched after auth modal
    const [queryUserMessage, { data, error, called }] = useLazyQuery(
        GET_MARKETING_MESSAGE_MODAL,
        {
            fetchPolicy: "network-only",
        },
    );
    const dispatch = useDispatch();
    useEffect(() => {
        if (called && !error && !!data) {
            const { marketingHeaderMessage } = data;
            // marketingHeaderMessage will either be { ... } or `null` (if none)
            if (typeof marketingHeaderMessage === "object") {
                dispatch(setMarketingMessage(marketingHeaderMessage));
            }
        }
    }, [data]);

    const refetchUserMessage = () => {
        // if on SSR page, refetch marketing message; else, don't.
        if (window.__NEXT_DATA__) {
            queryUserMessage();
        }
    };

    return {
        userMessage,
        refetchUserMessage,
    };
};
